const getters = {
  screen: state => state.app.screen,
  showFilter: state => state.app.showFilter,
  token: state => state.user.token,
  userId: state => state.user.userId,
  chatId: state => state.user.chatId,
  workStatus: state => state.user.workStatus,
  userInfo: state => state.user.userInfo,
  workorderDict: state => state.user.workorderDict,
  alarmInfo: state => state.alarm.alarmInfo,
  selfGroupIDs: state => state.rollBack.selfGroupIDs,
  instantOrderList: state => state.instant.instantOrderList,
  totalTodoNum: state => {
    return Object.values(state.patientFile.todoNums).reduce((sum, count) => sum + count, 0)
  },
  todoNums: state => state.patientFile.todoNums
  // roles: state => state.user.roles,
  // permission_routes: state => state.permission.routes,
  // errorLogs: state => state.errorLog.logs
}
export default getters
